module.exports = { raw: '8.11.2' };



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0 1